import { createSelector } from 'reselect';
import { pendingResponse } from '../../../fetchStatus';
import { serviceSelector } from '../service';

export const serviceAngeboteResponseSelector = createSelector([serviceSelector], service => service.serviceAngebote ?? pendingResponse);
